import React from 'react';
import PropTypes from 'prop-types';

import { Back } from '../back';
import { Icon } from '../icon';

// styles
import css from './head.sss';

// images
import CrossIconSvg from './images/cross.icon.svg';
import MoreVerticalIconSvg from './images/moreVertical.icon.svg';


export const Head = ({
    dataQa,
    onBack,
    onClose,
    actions,
    onSelectAction,
    hasUnreadMessage,
    children
}) => {

    const showAction = actions && actions.length;

    return (
        <div
            className={css.root}
            data-qaid={dataQa}
        >
            <div className={css.backHolder}>
                {onBack && (
                    <Back onClick={onBack} count={hasUnreadMessage} dataQA='back_btn' />
                )}
            </div>
            <div className={css.contentHolder}>
                {children}
            </div>
            <div className={css.controlsHolder}>
                {onClose && !showAction && (
                    <span className={css.close} onClick={onClose}>
                        <Icon glyph={CrossIconSvg} />
                    </span>
                )}

                {showAction && onSelectAction && (
                    <span className={css.actions}>
                        <Icon className={css.actionsIcon} glyph={MoreVerticalIconSvg} />
                        <select
                            className={css.actionsSelect}
                            onChange={onSelectAction}
                            defaultValue=''
                        >
                            <option value='' hidden />
                            {actions.map((item) => {
                                return (
                                    <option
                                        value={item.value}
                                        key={item.value}
                                    >
                                        {item.title}
                                    </option>
                                );
                            })}
                        </select>
                    </span>
                )}
            </div>
        </div>
    );
};

Head.propTypes = {
    actions: PropTypes.array,
    onSelectAction: PropTypes.func,
    dataQa: PropTypes.string,
    onBack: PropTypes.func,
    onClose: PropTypes.func,
    hasUnreadMessage: PropTypes.bool,
};
